import { Alert, Group, Switch } from "@mantine/core";
import { IconInfoTriangle } from "@tabler/icons-react";
import { useComposeFormContext } from "shared/components/message/compose/context";
import { features } from "shared/graphql/features";
import { useFormState } from "shared/hooks/useFormState";
import { MessageSeverity } from "src/gql/graphql";

export const UrgentSwitch = () => {
    const form = useComposeFormContext();
    const [severity, setSeverity] = useFormState(form, "severity");
    const hasCmOverrides = features.enabled("HAS_CM_DELIVERY_OVERRIDES");

    return (
        <Group>
            <Switch
                checked={severity == MessageSeverity.Urgent}
                onChange={(e) => setSeverity(e.target.checked ? MessageSeverity.Urgent : MessageSeverity.Informational)}
                label="Urgent"
                py="sm"
            />
            {severity == MessageSeverity.Urgent && hasCmOverrides && (
                <Alert
                    p="xs"
                    icon={<IconInfoTriangle />}
                    color="orange"
                    title="Urgent messages are sent to all verified phone numbers and devices."
                />
            )}
        </Group>
    );
};
